import { IAPIRoutes } from "../../../../config";

export type IReminderRepository = ReturnType<typeof ReminderRepositoryFactory>;

export const ReminderRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, PATCH, DELETE } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getReminders = async (payload: {
    clinic_id: number;
    patient_id: number;
  }): Promise<IGetRemindersResponse> =>
    GET(
      APIRoutes.apiGetReminders
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getReminderById = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
  }): Promise<IGetReminderResponse> =>
    GET(
      APIRoutes.apiGetReminderById
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id))
        .replace("{reminder_id}", String(payload.reminder_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const createReminder = async (
    payload: ICreateReminderPayload
  ): Promise<ICreateReminderResponse> =>
    POST(
      APIRoutes.apiCreateReminder
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id)),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const updateReminder = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
    data: IUpdateReminderPayload;
  }): Promise<IUpdateReminderResponse> =>
    PATCH(
      APIRoutes.apiUpdateReminder
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id))
        .replace("{reminder_id}", String(payload.reminder_id)),
      payload.data,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const deleteReminder = async (payload: {
    clinic_id: number;
    patient_id: number;
    reminder_id: number;
  }): Promise<IDeleteReminderResponse> =>
    DELETE(
      APIRoutes.apiDeleteReminder
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id))
        .replace("{reminder_id}", String(payload.reminder_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getReminders,
    getReminderById,
    createReminder,
    updateReminder,
    deleteReminder,
  };
};
